import { render, staticRenderFns } from "./ScanDialog.vue?vue&type=template&id=8c20c246&scoped=true"
import script from "./ScanDialog.vue?vue&type=script&lang=js"
export * from "./ScanDialog.vue?vue&type=script&lang=js"
import style0 from "./ScanDialog.vue?vue&type=style&index=0&id=8c20c246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c20c246",
  null
  
)

export default component.exports